import { useMutation } from '@tanstack/react-query';

import { SkyMapAxiosServiceFactory } from '../../../../services/axios/skymap-axios-service-factory';
import { useErrorHandling } from '../../../hooks/use-error-handling';
import { useProjectSnapshot } from '../../../hooks/use-project-snapshot';

type Props = {
  onSuccess: () => void;
};

const useRemoveProjectAttendeeMutation = ({ onSuccess }: Props) => {
  const { projectId } = useProjectSnapshot();
  const { handleError, buildErrorList } = useErrorHandling();

  const { mutate: removeProjectUser, isPending: pendingProjectUserRemoval } = useMutation({
    mutationFn: (userId: string) =>
      SkyMapAxiosServiceFactory.instance.createProjectServiceV0().removeUserFromProject({
        path: {
          projectId: projectId!,
          userId,
        },
      }),
    onError: (error) => handleError(error),
    onSuccess: () => {
      onSuccess();
    },
    retry: false,
    networkMode: 'always',
  });

  const { mutate: removeProjectUserInvitation, isPending: pendingProjectUserInvitationRemoval } =
    useMutation({
      mutationFn: (invitationId: string) =>
        SkyMapAxiosServiceFactory.instance
          .createProjectServiceV0()
          .removeUserInvitationsFromProject({
            path: {
              projectId: projectId!,
              invitationId,
            },
          }),
      onError: (error) => handleError(error),
      onSuccess: () => {
        onSuccess();
      },
      retry: false,
      networkMode: 'always',
    });

  return {
    removeProjectUser,
    removeProjectUserInvitation,
    pendingProjectUserRemoval,
    pendingProjectUserInvitationRemoval,
    buildErrorList,
  };
};

export { useRemoveProjectAttendeeMutation };
